 //export const config = require('../api/config/1950labs-prod.json');
export const config = require('../api/config/1950labs-testing.json');
//export const config = require('../api/config/1950labs-staging.json');